package domain.usecase

import domain.repository.AuthenticationRepository
import kotlinx.coroutines.flow.Flow

/**
 * Use case for observing authentication state changes
 */
class ObserveAuthenticationStateUseCase(
    private val authRepository: AuthenticationRepository
) {
    
    /**
     * Returns a flow that emits true when user is authenticated, false otherwise
     */
    fun execute(): Flow<Boolean> {
        return authRepository.observeAuthenticationState()
    }
    
    /**
     * Manually refresh authentication state (useful for checking cookies)
     */
    suspend fun refreshAuthState() {
        // Debug current state
        if (authRepository is data.repository.AuthenticationRepositoryImpl) {
            authRepository.debugAuthenticationState()
        }
        
        // Trigger a token check which will update the state if needed
        authRepository.getCurrentToken()
    }
    
    /**
     * Check for OAuth return (after user comes back from GitHub OAuth)
     */
    suspend fun processOAuthCallback() {
        authRepository.processOAuthCallback()
    }
}
